type UserState = {
  access_token: string | null
  user: {
    id: string
    first_name: string
    last_name: string
    status: string | null
    email: string
    permission_group_id: string | null
    created_at: string
    updated_at: string
    created_by: string | null
    updated_by: string | null
    user_role: string
    gender: string
    birth_date: string
    phone: string | null
    provider_name: string
    officer_id: string
    store_location_id: string
    type: string
  } | null
}

export const useUserStore = defineStore('userStore', {
  state: (): UserState => ({
    access_token: null,
    user: null
  }),
  actions: {
    login(nextState: UserState) {
      this.access_token = nextState.access_token
      this.user = nextState.user
    },
    logout() {
      this.access_token = null
      this.user = null
    },
    update(nextState: UserState['user']) {
      this.user = nextState
    }
  },
  persist: true
})
